module.exports = __webpack_public_path__ + "static/EsperMission.de-55f3c0124fe3ac30a15ee4118ecaa9f5.svg";